import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1984e565"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "close"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-v-guanbi1" }, null, -1))

import Avatar from "@/components/Avatar.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'ChatItem',
  props: {
  id: {
    type: String,
    required: true,
    default: "",
  },
  unreadCount: {
    type: Number,
    required: false,
    default: 0,
  },
  img: {
    type: String,
    required: true,
    default: "@/assets/icon.png",
  },
  username: {
    type: String,
    required: true,
    default: "",
  },
  text: {
    type: String,
    required: false,
    default: "",
  },
  showDel: {
    type: Boolean,
    required: true,
    default: false,
  },
  isGroup: {
    type: Boolean,
    required: false,
    default: false,
  },
  active: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["del"],
  setup(__props, { emit }) {

const props = __props;





const confirmEvent = () => {
  emit("del", props.id);
};

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["item", __props.active ? 'active' : ''])
  }, [
    _createVNode(_component_el_badge, {
      value: __props.unreadCount,
      hidden: __props.unreadCount === 0
    }, {
      default: _withCtx(() => [
        _createVNode(Avatar, {
          img: __props.img,
          name: __props.username
        }, null, 8, ["img", "name"])
      ]),
      _: 1
    }, 8, ["value", "hidden"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (__props.isGroup)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "[群]"))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(__props.username), 1)
      ]),
      (__props.text)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(__props.text), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.showDel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_popconfirm, {
            title: "确定要删除吗?",
            onConfirm: confirmEvent
          }, {
            reference: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})